import TaskIcon from '@plato/ui-legacy/assets/icons/task-icon';
import React from 'react';
import type { ActivityFeedRecord } from '../../../server/types/customer-activity-feed-types.ts';
import type { TaskPayload } from '../../../server/types/customer-activity.ts';
import type { TaskCompletedSource } from '../../analytics/types/analytics-events.ts';
import { useDialogs } from '../../dialogs/all-dialogs.tsx';
import { TimelineList } from '../../shared/components/timeline-list/timeline-list.tsx';
import { OpenTaskTimelineBody } from './open-task-timeline-body.tsx';
import { OpenTaskTimelineHeader } from './open-task-timeline-header.tsx';

type TaskItemProps = { activity: ActivityFeedRecord; source: TaskCompletedSource };

export const ActivityFeedTaskItem = React.forwardRef<HTMLDivElement, TaskItemProps>(
    ({ activity, source }, ref) => {
        const { payload } = activity;
        const task = payload as TaskPayload;
        const { openTaskDetails } = useDialogs();

        const handleClick = () => {
            openTaskDetails(task.taskId);
        };

        return (
            <TimelineList.Item icon={TaskIcon} ref={ref} onClick={handleClick}>
                <TimelineList.ItemHeader>
                    <OpenTaskTimelineHeader task={task} />
                </TimelineList.ItemHeader>
                <TimelineList.ItemBody>
                    <OpenTaskTimelineBody task={task} source={source} />
                </TimelineList.ItemBody>
            </TimelineList.Item>
        );
    },
);

ActivityFeedTaskItem.displayName = 'ActivityFeedTaskItem';
